export const version = '4.0.0-alpha.1';
